<template>
  <div>
    <nav-top @showProfile="showProfile" />
    <div class="container-fluid">
      <div class="row flex-xl-nowrap">
        <div :class="{ 'bd-banner-sidebar': isBannerEnabled }" class="col-12 col-md-3 col-xl-2 bd-sidebar">
          <nav-left />
          <span class="small d-none d-md-block text-muted custom-role">{{ userRole }}</span>
          <div class="custom-version">
            <span>Powered by OPUS IVS</span>
            <pre class="small d-none d-md-block text-muted"> v{{ version }} </pre>
          </div>
        </div>
        <main class="col-12 col-md-9 col-xl-10 py-3 px-md-5 bd-content" role="main">
          <slot />
          <div class="d-md-none">
            <hr />
            <pre class="small text-muted"> v{{ version }} </pre>
          </div>
        </main>
      </div>
    </div>
    <user-profile-dialog v-model="actionProfile" @closing="closeModal" @send="savedUserProfile" @sendChangePassword="performChangeProfilePassword" />
    <dialog-password v-model="actionChangePassword" @closing="closeModalPassword" @send="changeProfilePassword" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NavTop from '@/components/navigation/nav-top'
import NavLeft from '@/components/navigation/nav-left'
import UserProfileDialog from '@/components/users/forms/user-profile-dialog'
import DialogPassword from '@/components/users/forms/user-password'
export default {
  name: 'layout-sidebar',
  components: {
    NavTop,
    NavLeft,
    UserProfileDialog,
    DialogPassword
  },
  data() {
    return {
      actionProfile: null,
      actionChangePassword: null
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    version() {
      let _version = window.version ? window.version : ''
      return _version
    },
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    },
    userRole() {
      let _role = 'Admin'
      if (this.profile !== undefined && this.profile !== null) {
        switch (this.profile.roles[0]) {
          case 3:
            _role = 'Franchiser (admin)'
            break
          case 7:
            _role = 'Franchiser (user)'
            break
          case 8:
            _role = 'Franchisee (admin)'
            break
          case 9:
            _role = 'Franchisee (user)'
            break
          case 4:
            _role = 'Shop (admin)'
            break
          case 5:
            _role = 'Shop (user)'
            break
        }
      }
      return _role
    }
  },
  methods: {
    ...mapActions('lookups', ['setLookups']),
    ...mapActions('users', ['getUser', 'saveCredentials']),
    closeModal() {
      this.actionProfile = null
    },
    closeModalPassword() {
      this.actionChangePassword = null
    },
    async showProfile() {
      await this.setLookups({
        keys: [
          'ContactType',
          'Salutation',
          'AddressType',
          'PhoneType',
          'EmailType',
          'StateProvince',
          'Country',
          'RelatedContactType',
          'Language',
          'TimeZone'
        ],
        firm: 1,
        refresh: false
      })
      await this.getUser(this.profile.username)
      let user = {
        firm: this.profile.firm,
        user: this.profile.user,
        contact: this.profile.contact,
        contactType: null,
        username: this.profile.username,
        emailAddress: this.profile.email,
        firstName: this.profile.firstName,
        lastName: this.profile.lastName,
        roles: this.profile.roles.toString(),
        password: ''
      }
      this.actionProfile = user
    },
    savedUserProfile() {
      this.actionProfile = null
    },
    performChangeProfilePassword() {
      this.actionProfile = null
      let data = {
        firstName: this.profile.firstName,
        lastName: this.profile.lastName,
        user: this.profile.user,
        contact: this.profile.contact,
        username: this.profile.username
      }
      this.actionChangePassword = data
    },
    async changeProfilePassword(data) {
      await this.saveCredentials(data)
      this.actionChangePassword = null
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-role {
  margin-left: 5px;
}
.custom-version {
  position: fixed;
  bottom: 0;
  width: 100%;
  color: #fff;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/side-nav.vue